import { bootInstance } from "./instance.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".bhgpxs").forEach(bootInstance);
});
